module.exports = __webpack_public_path__ + "./fonts/EncodeSans-Bold.ttf";